var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgH1EmptyScreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.19 15H12.82A3.87 3.87 0 009 18.81v28.37A3.87 3.87 0 0012.81 51H36v9H26v4h24v-4H40v-9h23.18A3.87 3.87 0 0067 47.19V18.82A3.87 3.87 0 0063.19 15zM63 47H13V19h50v28zm-33.49-7.93l5.66-5.65-5.66-5.66 2.83-2.83L38 30.59l5.66-5.66 2.83 2.83-5.66 5.66 5.66 5.65-2.83 2.83L38 36.24l-5.66 5.66-2.83-2.83z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/H1_Empty_screen.4ed16db5.svg";
export { SvgH1EmptyScreen as ReactComponent };